module.exports = __webpack_public_path__ + "static/media/shopping-webfont.bc7e9c23.woff";